import { BlockComponentModel } from '@/cms/types/blok-component';

import VideoAccordion, { VideoAccordionProps } from '.';

type VideoAccordionStrapiProps = BlockComponentModel<VideoAccordionProps>;

function transformProps(props: VideoAccordionStrapiProps): VideoAccordionProps {
  return {
    header: props.block.header,
    accordions: props.block.accordions.map((accordion) => {
      const rawSrc = accordion.video?.src;

      // Safe extract: only if src is an object and has .data
      const isSrcStrapiObject =
        typeof rawSrc === 'object' &&
        rawSrc !== null &&
        'data' in rawSrc &&
        rawSrc.data?.attributes?.url;

      const srcUrl = isSrcStrapiObject
        ? rawSrc?.data?.attributes?.url
        : undefined;

      const fallbackUrl = accordion.video?.url?.trim() || undefined;

      const videoUrl = srcUrl || fallbackUrl;

      return {
        title: accordion.title,
        description: accordion.description,
        button: accordion.button,
        video: videoUrl
          ? {
              url: videoUrl,
            }
          : undefined,
      };
    }),
  };
}

const VideoAccordionStrapi = (props: VideoAccordionStrapiProps) => {
  const transformedProps = transformProps(props);

  return <VideoAccordion {...transformedProps} />;
};

export default VideoAccordionStrapi;
